export enum ComponentStyle {
  Material = 2,
  Mobile,
  DevExpress,
}

export interface IAbcComponent {
  id: string;
  class?: string;
}

export enum StylingMode {
  Outlined = 'outlined',
  Underlined = 'underlined',
  Filled = 'filled',
}

export enum LoaderStyle {
  Material,
  DevExpress,
  default,
}
